import {
  encartPackProduitsTitreTexteLogosMock,
  listingPackProduitsMock,
  texteSeoMock,
  titreDescriptionMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreDescriptionMock(),
  encartPackProduitsTitreTexteLogosMock(),
  listingPackProduitsMock('sinkAndTap'),
  texteSeoMock(),
];

export const packEviersMitigeurs: SlugPage = {
  ...pageBase({
    title: 'Pack Eviers et mitigeurs',
    type: 'pack',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
